import { AuthenticatedOrganizationUser } from "@biggeo/bg-server-lib/studio";
import React, { createContext, useContext } from "react";

export type UserContextProviderProps = {
    readonly user: AuthenticatedOrganizationUser;
    readonly children: React.ReactNode;
};

export const UserContext = createContext<
    AuthenticatedOrganizationUser | undefined
>(undefined);

export const UserContextProvider = ({
    user,
    children,
}: UserContextProviderProps) => {
    return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};

export const useUserContext = () => {
    const user = useContext(UserContext);
    if (!user) {
        throw new Error(
            "useUserContext must be used within a UserContextProvider"
        );
    }
    return user;
};
